import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { Button, Text } from '@beef/ui-kit';
import { I18n } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const CancelInvite = ({ invitationSentText, onClick }) => (
  <>
    <div className={cn('discription')}>
      <Text size="size5-r-s">
        {invitationSentText}
      </Text>
    </div>
    <Button variant="plain" onClick={onClick}>
      <Text size="size5-m">
        <I18n path="family.cancelInviteBtnText" />
      </Text>
    </Button>
  </>
);

CancelInvite.propTypes = {
  invitationSentText: PropTypes.string,
  onClick: PropTypes.func,
};

export { CancelInvite };
